import { Component, OnDestroy, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, AlertTriangle } from 'lucide-angular';

const NEW_SITE_URL = 'https://slhs.xqworkflow.com/';
const REDIRECT_SECONDS = 10;

@Component({
  selector: 'app-sunset-banner',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './sunset-banner.component.html',
  styleUrl: './sunset-banner.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SunsetBannerComponent implements OnInit, OnDestroy {
  AlertTriangle = AlertTriangle;

  readonly newSiteUrl = NEW_SITE_URL;
  countdown = signal<number>(REDIRECT_SECONDS);

  private timer?: ReturnType<typeof setInterval>;

  ngOnInit() {
    this.timer = setInterval(() => {
      const remaining = this.countdown() - 1;
      if (remaining <= 0) {
        this.goToNewSite();
      } else {
        this.countdown.set(remaining);
      }
    }, 1000);
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  goToNewSite() {
    this.clearTimer();
    window.location.href = this.newSiteUrl;
  }

  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }
}
